import UserPageSubOverView from "./user-overview-sub-page";


const UserPageSub = {
    OverView : UserPageSubOverView,
};

export default UserPageSub;